export default __webpack_public_path__ + "static/media/forked.0b943692.png";